import coreBase from "@nextories/vue-core-components/src/i18n/langs/fr/base";
import base from "@nextories/vue-tasks/src/i18n/langs/fr/base";

export default {
  ...base,
  title: "SmartCall",
  next: "Suivant",
  back: "< Retour",
  continue: "Continuer",
  titleSuccess: {
    ...base.titleSuccess,
  },
  messageSuccess: {
    ...base.messageSuccess,
    refresh: {
      ...base.messageSuccess.refresh,
      project: 'Le projet a été rafraîchi.',
    },
    deleteLock: 'Le blocage a été supprimé avec succès.',
  },
  titleError: {
    ...base.titleError,
    step: "Veuillez corriger le formulaire",
  },
  messageError: {
    ...coreBase.messageError,
    ...base.messageError,
    refreshProject: 'Une erreur est survenue pendant l\'actualisation de la liste du projet.',
    slotAvailable: "Le créneau de réservation est indisponible.",
    slotsAvailable: "Les créneaux de réservation sont temporairement indisponibles.",
    invalidStep: "Le formulaire de l'étape en cours est invalide.",
    step: "Redirection vers le formulaire de l`étape <b>« {name} »</b>",
    formDirty: "Avant de continuer, veuillez vérifier le formulaire.",
    deleteLock: 'Une erreur est survenue pendant la suppression du blocage.',
  },
  titleWarning: {
    ...base.titleWarning,
    deleteLock: 'ATTENTION: Le créneau sera libéré',
  },
  messageWarning: {
    ...base.messageWarning,
    formDirty: 'Le formulaire n\'est pas valide. Continuer quand même ?',
    deleteLock: 'Le créneau qui était pré-bloqué le {date} avec <b>{firstName} {lastName}</b> sera libéré. Etes vous sûr ?',
  },
  tooltip: {
    ...base.tooltip,
    skip: "Passer le projet",
    nextSheet: "Projet suivant",
    disabledNextSheet: "Veuillez faire une action avant de passer au projet suivant",
    updateProject: 'Mise à jour en cours...',
    refreshProject: "Rafraîchir le projet",
    refreshCalcEstimate: "Rafraîchir l'estimation",
    refreshGetMeetingSlot: 'Rafraîchir le planning',
    forceRefreshGetMeetingSlot: 'Forcer le rafraîssement du planning',
  },
  documentTitle: {
    ...base.documentTitle,
    dashboard: '@:base.title - Nextories',
    home: '@:base.title - Tâches',
  },
  menu: {
    ...base.menu,
    dashboard: 'Home',
  },
  ignoreStep: "Ignorer cette étape >",
  calcVolume: "Calculer votre volume",
};
